import React from 'react';
import { FileUploader } from '../shared/file-uploader';

interface MMPKProps {
  startUpload: boolean;
  onUploadBegin: () => {},
  onComplete: () => {};
  onError: () => {};
  maxFiles: number;
}

interface Props {
  isNew: boolean;
  fileUploaderProps: MMPKProps;
  setLayerFile: (key: string, name: string) => {},
}

const MMPKLayer: React.FC<Props> = ({
  isNew, fileUploaderProps, setLayerFile,
}: Props) => {
  const getPresignedUrl = async ({ file }) => {
    const response = await fetch('/api/v2/file/upload_url.json');

    const { file: { url, key, method } } = await response.json();

    setLayerFile(key, file.name);

    return { method, body: file, url };
  };

  if (isNew) {
    return (
      <FileUploader
        {...fileUploaderProps}
        onUploadParams={getPresignedUrl}
        acceptedFileTypes=".mmpk"
        acceptedFilesName="MMPK"
      />
    );
  }

  return null;
};

export default MMPKLayer;
